import { partners } from './content.js';

/**
 * The customer logo band.
 *
 * Returns null when nobody has agreed to be named, which is the state today.
 * That is the whole design: an empty logo wall — grey boxes, "your logo here",
 * a lonely single mark — tells a buyer that no customer would put their name
 * to this. Saying nothing says less than that.
 *
 * So the section exists, is styled, is tested, and does not appear. Adding the
 * first real customer is one entry in `partners` in src/content.ts, and the
 * band appears with it.
 */
export function Partners() {
  if (partners.length === 0) return null;

  return (
    <section className="partners" aria-labelledby="partners-title">
      <div className="partners__inner">
        <h2 className="partners__title" id="partners-title">
          {partners.length === 1 ? 'Where it is running today' : 'Where it is running'}
        </h2>
        <ul className="partners__list">
          {partners.map((partner) => (
            <li className="partners__item" key={partner.name}>
              {/* The organisation's own mark, at the size they supply it. Never
                  recoloured, never set on a tinted panel: a logo used outside
                  its owner's brand rules is a second thing to apologise for. */}
              <img
                className="partners__logo"
                src={partner.logo}
                alt={partner.name}
                loading="lazy"
                decoding="async"
              />
              {partner.note ? <p className="partners__note">{partner.note}</p> : null}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
